import { HeroContent } from "./HeroContent";
import { MixlrPlayer } from "./MixlrPlayer";

export const Header = ({ data }) => {
  const scrollToDonate = () => {
    document.getElementById('donateAnchor').scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <MixlrPlayer />
            <div className="row">
              <HeroContent
                title={data?.title}
                paragraph={data?.paragraph}
                onDonateClick={scrollToDonate}
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
